export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-logotypes/dogecoin-doge-logo-950f315add0c4ba860bf47ec6480b4ea.png";